import { NgClass, AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { map } from 'rxjs/operators';
import { UserFeed } from '@bn/dashboard-shared/models';
import { UserNotificationService } from '@bn/dashboard-shared/services';
import { APP_CONFIG } from '@bn/shared/entities/injection-tokens';
import { DateTimeFormat } from '@bn/shared/utils';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { DropdownMenuComponent } from '@bn/web-ui/dropdown-menu/dropdown-menu.component';
import { BnNotificationItemComponent } from '@bn/web-ui/notification-item/notification-item.component';
import { BadgeComponent } from '@bn/web-ui/badge/badge.component';

@Component({
  selector: 'bn-dashboard-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  imports: [
    FaIconComponent,
    RouterLink,
    RouterLinkActive,
    DropdownMenuComponent,
    NgClass,
    BnNotificationItemComponent,
    ButtonComponent,
    AsyncPipe,
    BadgeComponent,
  ],
})
export class NotificationsComponent {
  readonly #APP_CONFIG = inject(APP_CONFIG);
  private readonly notificationService = inject(UserNotificationService);

  @Input()
  public isMobile = false;

  public unreadFeeds: UserFeed[] = [];

  public readonly dateFormat = DateTimeFormat.DayLongMonthShortYearLong;
  public readonly showLastLength = this.#APP_CONFIG.userFeeds.showLastLength.notificationsDropdown;
  public readonly userFeed$ = this.notificationService.userFeed$;
  public readonly userFeedUnread$ = this.userFeed$.pipe(
    map((feeds) => {
      this.unreadFeeds = (feeds ?? []).filter((item) => !item.isRead);

      return this.unreadFeeds;
    }),
  );

  public onCloseDropdown(isOpened: boolean): void {
    if (!isOpened && this.unreadFeeds.length) this.notificationService.markSelectedAsRead(['user-notification', 'user-whats-new']);
  }
}
